export default "/images/fast_credit.png?f32b8cfc73f8cb62a8e0831fb0294179";